<template>
  <v-card class="report-row" flat>
    <div class="row total">
      <div class="col-6">SKUPAJ:</div>
      <div class="col-6 text-right">{{totalSum | price(2)}}</div>
    </div>
    <div class="row" v-for="device in devices" :key="device.name">
      <div class="col-6 py-1">{{device.name}}</div>
      <div class="col-6 py-1 text-right">{{device.total | price(2)}}</div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    totalSum: {
      required: true,
      type: Number
    },
    devices: {
      required: true,
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.report-row {
  padding: 0 15px;
  margin: 5px;
  margin-bottom: 15px;
  font-size: 20px;

  .total {
    font-size: 30px;
    font-weight: bold;
  }
}
</style>
